import React, { useEffect, useState } from "react";
import "./ContactPage.scss"
import MenuNavbarMini from "../../../components/Navbar/MenuNavbarMini";
import MenuFooterMini from "../../../components/Footer/MenuFooter/MenuFooterMini";
import { contactEnquiry } from "../../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";
import msg from "../../../assets/message.svg"
import phone from "../../../assets/phone-line.svg"
import mic from "../../../assets/headset.svg"
import CustomInput from "../../../components/CustomInput/CustomInput";
import CustomDropdown from "../../../components/CustomDropdown/CustomDropdown";
import CustomTextArea from "../../../components/CustomInput/CustomTextArea";
import MenuFooter from "../../../components/Footer/MenuFooter/MenuFooter";


const ContactPage = () => {
    const issues = [
        { label: "Order Issues", value: "Order Issues" },
        { label: "Account Problems", value: "Account Problems" },
        { label: "Technical Support", value: "Technical Support" },
        { label: "Billing Inquiries", value: "Billing Inquiries" },
        { label: "General Questions", value: "General Questions" },

    ];
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [orderID, setOrderID] = useState("")
    const [subject, setSubject] = useState(issues[0])
    const companyDetails = useSelector((state) => state.companyData.company)
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        message: ""
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)

    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        let newErrors = {
            fullName: "",
            email: "",
            message: ""
        }
        if (fullName.trim() === "") {
            newErrors.fullName = "*Required";
            valid = false;
        }
        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        if (email.trim() === "") {
            newErrors.email = "*Required";
            valid = false;
        }
        else if (!validateEmail(email)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": companyDetails?.ID || "",
            "Name": fullName,
            "Email": email,
            "PhoneNo": "",
            "Message": message,
            "Subject": subject.value,
            "OrderID": orderID,
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFullName("")
                setMessage("")
                setLoading(false)
                setShowSuccess(true)
                setOrderID("")
                setSubject(issues[0])
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const faq = [
        {
            sub: "How do I track my order?",
            value: "Track your current order status"
        },
        {
            sub: "Refund Policy",
            value: "Learn about our refund process"
        },
        {
            sub: "Delivery Areas",
            value: "Check if we deliver to your area"
        }
    ]
    useEffect(() => {
        localStorage.removeItem("QUANTITY")
        localStorage.removeItem("ITEM")
        localStorage.removeItem("MODQUANTITY")
    }, [])
    return (
        <div className="HospitalityV2ContactPage">
            <MenuNavbarMini />
            <div className="contact-page">
                <div className="contact-page-header">How Can We Help You?</div>
                <div className="contact-page-subheader">Our support team is here to assist you with any questions or concerns</div>
                <div className="contact-page-inner">
                    <div className="contact-page-inner-left">
                        <div className="form-header-contact">
                            Contact Form
                        </div>
                        <div className="input-flex-form">
                            <CustomInput
                                required
                                value={fullName}
                                onChange={(e) => {
                                    setFullName(e.target.value)
                                    setErrors({ ...errors, fullName: "" })

                                }}
                                placeholder={"Enter your name"}
                                label={"Name"}
                                error={errors.fullName !== ""}
                                errorText={errors.fullName}
                            />
                            <CustomInput
                                required
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value)
                                    setErrors({ ...errors, email: "" })

                                }}
                                placeholder={"Enter your email"}
                                label={"Email"}
                                error={errors.email !== ""}
                                errorText={errors.email}
                            />
                        </div>
                        <div className="input-flex-form">
                            <CustomInput
                                value={orderID}
                                onChange={(e) => {
                                    setOrderID(e.target.value)

                                }}
                                placeholder={"Enter your order number if applicable"}
                                label={"Order Number (Optional)"}
                            />
                        </div>
                        <div className="input-col-form">
                            <div className="input-col-form-lable">
                                Issue Category
                            </div>
                            <CustomDropdown
                                items={issues} selected={subject}
                                setSelected={setSubject}
                                showSortText={false}
                                width={"100%"}
                            />
                        </div>
                        <div className="input-flex-form">
                            <CustomTextArea
                                label={"Message"}
                                placeholder="Tell us more about your question or request..."
                                value={message}
                                error={errors.message !== ""}
                                onChange={(e) => {
                                    setMessage(e.target.value)
                                    setErrors({ ...errors, message: "" })

                                }}
                                errorText={errors.message}
                                required
                            />
                        </div>
                        {showSuccess && <div className="succes-alert">
                            ✔ Thank you for contacting us! We appreciate your message and will be in touch shortly .
                        </div>}
                        <div className="form-btn-contact"
                            onClick={handleContact}>
                            {loading && <div className="loader-btn" />}

                            Submit Request
                        </div>
                    </div>
                    <div className="contact-page-inner-right">
                        {/* <div className="contact-item-container">
                            <div className="contact-item-container-header">
                                <div className="contact-item-container-header-text">
                                    Live Chat
                                </div>
                                <div className="online-text">
                                    <div className="online" />Online</div>
                            </div>
                            <div className="live-chat-container">
                                <div className="live-chat-container-text">
                                    Get instant help from our support team
                                </div>
                                <div className="live-chat-container-btn disable">
                                    <img alt="" src={msg} />
                                    Start Chat
                                </div>
                            </div>
                        </div> */}
                        <div className="contact-item-container">
                            <div className="contact-item-container-header">
                                <div className="contact-item-container-header-text">
                                    Phone Support
                                </div>
                            </div>
                            <div className="phone-sup-container">
                                <div className="phone-sp-wrp">
                                    <img alt="" src={phone} className="phone-ico" />
                                    <div className="phone-sp-wrp-content">
                                        <div className="sup-number">+44 {companyDetails?.Phone}</div>
                                        <div className="sup-text">
                                            Toll-free number
                                        </div>
                                    </div>
                                </div>
                                <div className="phone-hrs">
                                    <div className="phone-hrs-header">Support Hours
                                    </div>
                                    {companyDetails?.OpeningHour?.map((open, key) => {
                                        if (open?.Closed) return null;
                                        return (
                                            <div key={key} className="opening-hours-text">
                                                <div>{open.Day}</div>
                                                <div>
                                                    {open?.OpenHours?.map((date, idx) => (
                                                        <div key={idx}>
                                                            {date?.StartTime} - {date?.EndTime}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    })}

                                </div>
                            </div>
                        </div>
                        <div className="contact-item-container">
                            <div className="contact-item-container-header">
                                <div className="contact-item-container-header-text">
                                    Expected Response Time
                                </div>
                            </div>
                            <div className="res-exp-container">
                                {/* <div className="res-exp-container-item">
                                    <div className="res-exp-container-item-left">
                                        <img alt="" src={msg} className="msg-ico" />
                                        Live Chat</div>
                                    <div className="res-exp-container-item-right">Instant</div>
                                </div> */}
                                <div className="res-exp-container-item">
                                    <div className="res-exp-container-item-left">
                                        <img alt="" src={phone} className="phn-ico" />
                                        Phone Support</div>
                                    <div className="res-exp-container-item-right">2-5 minutes</div>
                                </div>
                                <div className="res-exp-container-item">
                                    <div className="res-exp-container-item-left">
                                        <img alt="" src={mic} className="mic-ico" />
                                        Email Support</div>
                                    <div className="res-exp-container-item-right">24-48 hours</div>
                                </div>
                            </div>

                        </div>
                        <div className="contact-item-container">
                            <div className="contact-item-container-header">
                                <div className="contact-item-container-header-text">
                                    Popular FAQs
                                </div>
                            </div>
                            <div className="faq-container">
                                {faq.map((fq, key) => {
                                    return (
                                        <div className="fq-item" key={key}>
                                            <div className="fq-item-sub">
                                                {fq.sub}
                                            </div>
                                            <div className="fq-item-val">
                                                {fq.value}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MenuFooter />
        </div>
    )
}
export default ContactPage